var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.826 0.250094H8.174C6.13873 0.250094 4.18682 1.0586 2.74766 2.49776C1.30851 3.93691 0.5 5.88882 0.5 7.92409C0.5 9.95936 1.30851 11.9113 2.74766 13.3504C4.18682 14.7896 6.13873 15.5981 8.174 15.5981H9V19.2501C8.99997 19.3502 9.02996 19.4479 9.08609 19.5307C9.14222 19.6136 9.22192 19.6777 9.31486 19.7147C9.40781 19.7518 9.50973 19.7601 9.60745 19.7386C9.70517 19.7171 9.79419 19.6667 9.863 19.5941L13.648 15.5941H15.826C17.8613 15.5941 19.8132 14.7856 21.2523 13.3464C22.6915 11.9073 23.5 9.95537 23.5 7.92009C23.5 5.88482 22.6915 3.93291 21.2523 2.49376C19.8132 1.0546 17.8613 0.246094 15.826 0.246094V0.250094Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.a493aa7b858517f2c5a678a87f7b8722.svg";
export { ForwardRef as ReactComponent };